import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";

import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

import { useDispatch } from "react-redux";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";

import BMXUserView from "../../../../../Components/BMXUserView/BMXUserView";

import BMXAutocomplente from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";
import "./AddProjectStepTwo.scss";
const AddProjectStepTwo = ({ workers, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [departments, setDepartments] = useState([]);

  // NEW COMPONENET

  const { values, form } = props;

  const fetchData = async () => {
    const departmentsFetch = GlobalAuthFetch({
      path: "/department/all",
    });

    const [departmentsPayload] = await Promise.all([departmentsFetch]);

    setDepartments(departmentsPayload?.payload?.data || []);
  };
  useEffect(() => {
    // LOADING DICTIONARIS

    fetchData();
  }, []);

  return (
    <div className="AddProjectStepTwo" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:project.participants")} />
      <div className="participants-container">
        <div className="participants-box">
          <Field
            component={BMXAutocomplente}
            data-cy="participatingUnits"
            options={departments}
            currentValues={values}
            label={`${t("global:project.participatingUnits")}`}
            limitTags={1}
            multiple
            getOptionLabel={(option) => String(`${option.name}`)}
            renderOption={(props, option) => (
              <li key={option.uuid} {...props}>
                <BMXUserView color="primary" department={option}></BMXUserView>
              </li>
            )}
            renderTags={(values) => {
              return values.map((option, index) => (
                <BMXUserView
                  comma={values.length - 1 !== index}
                  key={option.uuid}
                  color="primary"
                  department={option}
                ></BMXUserView>
              ));
            }}
            name="participatingUnits"
          />
          <div className="summary">
            <div className="area">
              {values?.participatingUnits?.map((el) => (
                <BMXUserView
                  className="mt-2"
                  line={"line"}
                  color="secondary"
                  department={el}
                ></BMXUserView>
              ))}
            </div>
          </div>
        </div>
        <div className="participants-box">
          <Field
            component={BMXAutocomplente}
            options={workers}
            data-cy="projectParticipants"
            currentValues={values}
            label={t("global:project.projectParticipants")}
            limitTags={1}
            multiple
            name="projectParticipants"
            renderOption={(props, option) => (
              <li key={option.uuid} {...props}>
                <BMXUserView color="primary" user={option}></BMXUserView>
              </li>
            )}
            getOptionLabel={(option) =>
              String(
                `${option?.lastName} ${option?.firstName} ${option?.firstName} ${option?.lastName}`
              )
            }
            renderTags={(values) => {
              return values.map((option, index) => (
                <BMXUserView
                  comma={values.length - 1 !== index}
                  key={option.uuid}
                  color="primary"
                  user={option}
                ></BMXUserView>
              ));
            }}
          />
          <div className="summary">
            <div className="area">
              {values?.projectParticipants &&
                Array.isArray(values.projectParticipants) &&
                values.projectParticipants.map((el) => (
                  <BMXUserView
                    className="mt-2"
                    line={"line"}
                    color="primary"
                    user={el}
                  ></BMXUserView>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProjectStepTwo;
